var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: ["insert-rec", "insert-shop-card", "shop-house", _vm.expiredClass],
    },
    [
      _c(
        "a",
        {
          staticClass: "insert-box",
          attrs: {
            href: "javascript:void(0);",
            "data-spm-data": "h",
            "data-spm-content": _vm.dataSpmContent,
          },
        },
        [
          _c("div", { staticClass: "img-box img-do" }, [
            _c("img", {
              staticClass: "insert-article__img",
              attrs: { src: _vm.image, alt: "配图" },
            }),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "insert-content" }, [
            _c("h5", { staticClass: "insert-rec__title" }, [
              _vm._v(_vm._s(_vm.title)),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "footer" }, [
              _vm.p1 ? _c("p", [_vm._v(_vm._s(_vm.p1))]) : _vm._e(),
              _vm._v(" "),
              _vm.p2 ? _c("p", [_vm._v(_vm._s(_vm.p2))]) : _vm._e(),
              _vm._v(" "),
              _vm.p3 ? _c("p", [_vm._v(_vm._s(_vm.p3))]) : _vm._e(),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticStyle: { clear: "both" } }),
          _vm._v(" "),
          _c("div", { staticClass: "shop-house-opare" }, [
            _c("div", { staticClass: "input-box name-input-box" }, [
              _c("span", { staticClass: "col-title" }, [_vm._v("姓名")]),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model.trim",
                    value: _vm.nameInput,
                    expression: "nameInput",
                    modifiers: { trim: true },
                  },
                ],
                staticClass: "col-input",
                attrs: { type: "text", placeholder: "请输入姓名" },
                domProps: { value: _vm.nameInput },
                on: {
                  click: _vm.hideError,
                  input: function ($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.nameInput = $event.target.value.trim()
                  },
                  blur: function ($event) {
                    _vm.$forceUpdate()
                  },
                },
              }),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "input-box telephone-input-box" }, [
              _c("span", { staticClass: "col-title" }, [_vm._v("手机")]),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model.trim",
                    value: _vm.telephoneInput,
                    expression: "telephoneInput",
                    modifiers: { trim: true },
                  },
                ],
                staticClass: "col-input",
                attrs: {
                  type: "text",
                  maxlength: "11",
                  placeholder: "请输入手机号",
                },
                domProps: { value: _vm.telephoneInput },
                on: {
                  click: _vm.hideError,
                  input: function ($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.telephoneInput = $event.target.value.trim()
                  },
                  blur: function ($event) {
                    _vm.$forceUpdate()
                  },
                },
              }),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "input-box code-input-box" }, [
              _c("span", { staticClass: "col-title" }, [_vm._v("验证码")]),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.codeInput,
                    expression: "codeInput",
                  },
                ],
                staticClass: "col-input",
                attrs: {
                  type: "text",
                  placeholder: "请输入验证码",
                  maxlength: "6",
                },
                domProps: { value: _vm.codeInput },
                on: {
                  click: _vm.hideError,
                  input: function ($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.codeInput = $event.target.value
                  },
                },
              }),
              _vm._v(" "),
              _c(
                "span",
                { staticClass: "get-code-btn", on: { click: _vm.getMsgCode } },
                [
                  _c("span", { staticClass: "btn-text" }, [
                    _vm._v(_vm._s(_vm.codeText)),
                  ]),
                ]
              ),
            ]),
          ]),
          _vm._v(" "),
          _vm.showErrorTip
            ? _c("span", { staticClass: "error-tip" }, [
                _vm._v(_vm._s(_vm.errorText)),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.isOverdue
            ? _c(
                "div",
                {
                  staticClass:
                    "insert-btn enroll-btn enroll-btn-done fixPosition",
                },
                [_vm._v("报名结束")]
              )
            : _c(
                "div",
                {
                  staticClass:
                    "insert-btn enroll-btn show-enroll-btn fixPosition",
                  on: { click: _vm.showEnrollBox },
                },
                [_vm._v(_vm._s(_vm.enrollText))]
              ),
        ]
      ),
      _vm._v(" "),
      _c("div", { staticStyle: { clear: "both" } }),
      _vm._v(" "),
      _vm.showDialogTip
        ? _c("div", { staticClass: "dialog-tip" }, [
            _vm._v(_vm._s(_vm.dialogTipText)),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.cardInfo.accountName && _vm.cardInfo.avatar
        ? _c("div", { staticClass: "rec" }, [
            _c("div", { staticClass: "rec-avator" }, [
              _c("img", { attrs: { src: _vm.cardInfo.avatar } }),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "rec-text" }, [
              _vm._v(_vm._s(_vm.cardInfo.accountName) + "推荐"),
            ]),
            _vm._v(" "),
            _vm.status === 4 || _vm.status === 3
              ? _c("div", { staticClass: "rec-expired-tag" }, [
                  _vm._v("已失效"),
                ])
              : _vm._e(),
          ])
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }